import request from '@/utils/request'
// import requestNew from '@/utils/requestNew'
export function getQAList (url, params) {
  return request({
    url: url,
    method: 'get',
    // async: false,
    params: params
  })
}
export function getQALType (url, params) {
  return request({
    url: url,
    method: 'get',
    // async: false,
    params: params
  })
}
export function addLabel (url, params) {
  return request({
    url: url,
    method: 'get',
    params: params
  })
}

export function addQA (url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}

export function delQA (url, params) {
  return request({
    url: url,
    method: 'get',
    params: params
  })
}

export function updateQA (url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}

// export function getQALogList (url, params) {
//   return requestNew({
//     url: url,
//     method: 'get',
//     params: params
//   })
// }
//
// export function getQALogStatistics (url) {
//   return requestNew({
//     url: url,
//     method: 'get'
//     // params: params
//   })
// }
//
// export function exportLogList (url, params) {
//   return requestNew({
//     url: url,
//     method: 'post',
//     params: params,
//     responseType: 'blob'
//   })
// }
// export function download (url) {
//   return requestNew({
//     url: url,
//     method: 'get'
//   })
// }

export function logIn (url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}

export function updatePassword (url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}

export function uploadImg (url, params) {
  return request({
    url: url,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function post (url, params) {
  return request({
    url: url,
    method: 'post',
    data: params

  })
}
export function getOBj (url) {
  return request({
    url: url,
    method: 'get'

  })
}

export function get (url, params) {
  return request({
    url: url,
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js